import { memo, FC } from 'react'
import styles from './index.module.scss'

interface ShadowViewProps {
  style?: any
}

const ShadowView: FC<ShadowViewProps> = ({ style }) => {
  return <div className={styles.shadow} style={style} />
}

export default memo(ShadowView)
